import { render, staticRenderFns } from "./BuildingListing.vue?vue&type=template&id=16297d38"
import script from "./BuildingListing.vue?vue&type=script&lang=js"
export * from "./BuildingListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports